import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="w-full bg-white py-20 md:py-32 px-4" data-id="element-135">
      <div className="max-w-4xl mx-auto text-center" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-137">
          <h2 className="text-4xl md:text-6xl font-black mb-8" data-id="element-138">
            Necesitás un <span className="bg-yellow-400 px-2" data-id="element-139">sistema</span>, no
            más motivación
          </h2>

          <p className="text-xl md:text-2xl text-gray-700 leading-relaxed" data-id="element-140">
            Este método está diseñado para funcionar incluso cuando no tenés
            ganas.
            <br data-id="element-141" />
            <span className="font-bold" data-id="element-142">Paso a paso. Simple. Sin vueltas.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}